import { doc, onSnapshot } from 'firebase/firestore';
import { db, storage } from '../lib/firebase';

export type PublicIdentity = { clinicName: string | null; logoUrl: string | null; contractEnded: boolean };

/** Forma do doc system_settings/public_identity (escrito so pelo servidor). */
export type PublicIdentityDoc = { clinicName?: unknown; hasLogo?: unknown; logoVersion?: unknown; contractEnded?: unknown };

export function windowTitle(clinicName: string | null | undefined): string {
  const name = clinicName?.trim();
  return name ? `Ardix · ${name}` : 'Ardix';
}

// Mesmo gatilho do firebase.ts: no emulador o Storage fica em 127.0.0.1:9199, nao na producao.
const STORAGE_HOST =
  import.meta.env.VITE_USE_EMULATORS === '1' ? 'http://127.0.0.1:9199' : 'https://firebasestorage.googleapis.com';

export function publicLogoUrl(bucket: string, version: string, host: string = STORAGE_HOST): string {
  return `${host}/v0/b/${bucket}/o/public_identity%2Flogo?alt=media&v=${encodeURIComponent(version)}`;
}

/** Doc cru -> identidade. Ausente/malformado => tudo null (nunca quebra a tela). */
export function toPublicIdentity(data: PublicIdentityDoc | null | undefined, bucket: string): PublicIdentity {
  if (!data) return { clinicName: null, logoUrl: null, contractEnded: false };
  const clinicName = typeof data.clinicName === 'string' && data.clinicName.trim() ? data.clinicName : null;
  const logoUrl =
    data.hasLogo === true && typeof data.logoVersion === 'string' && data.logoVersion && bucket
      ? publicLogoUrl(bucket, data.logoVersion)
      : null;
  return { clinicName, logoUrl, contractEnded: data.contractEnded === true };
}

export function storageBucket(): string {
  return storage.app.options.storageBucket ?? '';
}

export function subscribePublicIdentity(
  cb: (data: PublicIdentityDoc | null) => void,
  onErr: (err: Error) => void,
): () => void {
  return onSnapshot(
    doc(db, 'system_settings/public_identity'),
    (snap) => cb(snap.exists() ? (snap.data() as PublicIdentityDoc) : null),
    onErr,
  );
}
